<template>
  <div class="bg-wave-card border border-outeline-color px-3 py-4 round-8">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.bg-wave-card {
  background: linear-gradient(180deg, rgb(255 255 255 / 60%) 0%, #fff 60.94%),
    url("~@/assets/img/bg_wave.png"), #fff;
  background-repeat: repeat;
}
</style>
